import { AccountTypeService } from '../services/account-type.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Observable, map } from 'rxjs'

@Injectable()
export class OonEnabledGuard implements CanActivate {
  constructor(
    private router: Router,
    private accountTypeService: AccountTypeService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.accountTypeService.getOonIntegrationEnabled().pipe(
      map((enabled) => {
        if (enabled) {
          return true
        }
        this.router.navigate(['/dashboard'])
        return false
      })
    )
  }
}
